<template>
    <MasterTemplate 
        title="ข้อมูลบริษัท" 
        :headers="headers" 
        :setData="setData"
        itemKey="companyId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-text-field label="รหัสบริษัท" autofocus maxlength="20" v-model="editedItem.companyCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="ชื่อบริษัท" maxlength="100" v-model="editedItem.companyName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="เลขประจำตัวเสียภาษี" maxlength="20" v-model="editedItem.taxId" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="เบอรโทร" maxlength="100" v-model="editedItem.tel" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="แฟกซ์" maxlength="100" v-model="editedItem.fax"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-text-field label="ที่อยู่" maxlength="1000" v-model="editedItem.address"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listCompany, isExistCompanyCode, insert, update, deleteCompany} from '@/api/master/company-api.js'

export default {
    name: 'Company',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสบริษัทซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.companyCode': function(newVal, oldVal) {
            if (!this.editedItem.companyId) {
                this.editedItem.companyId = '-1';
            }
            if (newVal && this.editedItem.companyId) {
                isExistCompanyCode(newVal, this.editedItem.companyId).then(response => {
                    this.isDup = response;
                }).catch(e => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'รหัสบริษัท', value: 'companyCode'},
            {text: 'ชื่อบริษัท', value: 'companyName'},
            {text: 'เลขประจำตัวสียภาษี', value: 'taxId'},
            {text: 'โทร', value: 'tel'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            companyId: '-1',
            companyCode: '',
            companyName: '',
            taxId: '',
            tel: '',
            fax: '',
            address: ''
        }
    }),
    methods: {
        listData() {
            return listCompany()
        },
        deleteData(item) {
            return deleteCompany(item.companyId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.companyName;
        },
        setData(item) {
            this.editedItem = item;
        }
    }
}
</script>
